import { Check } from "lucide-react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1694521787162-5373b598945c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjaXZpbCUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjB3b3JrZXJ8ZW58MHx8fHwxNzc3NDA2NDAwfDA&ixlib=rb-4.1.0&q=85";

const VALUES = [
    "Calidad técnica certificada en cada etapa.",
    "Cumplimiento de plazos y presupuestos.",
    "Equipo propio y supervisión profesional.",
    "Seguridad e higiene como prioridad absoluta.",
];

export default function Nosotros() {
    return (
        <section id="nosotros" className="relative py-24 md:py-32 bg-[#0A0A0A]" data-testid="nosotros-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <div className="lg:col-span-7">
                    <p className="overline" data-testid="nosotros-overline">Nosotros</p>
                    <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95]" style={{ fontFamily: "Chivo" }} data-testid="nosotros-title">
                        Soluciones <span className="text-[#14888F]">óptimas</span>,<br />
                        calidad y <span className="text-[#14888F]">eficiencia</span>.
                    </h2>

                    <div className="mt-10 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
                        <p>
                            Somos un equipo creciente, especializados en la <strong className="text-white">construcción</strong> y el <strong className="text-white">mantenimiento industrial</strong>, dedicados a ofrecer soluciones óptimas a usuarios que buscan calidad y eficiencia en sus características edilicias y procesos productivos.
                        </p>
                        <p>
                            La trayectoria desde el <strong className="text-white">2017</strong> en la zona central del país propició a que el equipo se desarrolle en diversas áreas, adquiriendo sólidas experiencias y capacitándose en productos y sistemas constructivos de vanguardia.
                        </p>
                        <p>
                            Hoy traemos al <strong className="text-white">NEA</strong> el conocimiento y el entusiasmo para crear un camino destacable y perdurable en nuestras tierras.
                        </p>
                    </div>

                    <ul className="mt-10 grid sm:grid-cols-2 gap-4 max-w-xl" data-testid="nosotros-values">
                        {VALUES.map((v, i) => (
                            <li key={i} className="flex items-start gap-3" data-testid={`value-${i}`}>
                                <span className="mt-0.5 flex-shrink-0 w-6 h-6 bg-[#14888F]/15 border border-[#14888F]/40 flex items-center justify-center">
                                    <Check size={14} className="text-[#14888F]" />
                                </span>
                                <span className="text-sm md:text-base text-white/85">{v}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-5 relative">
                    <div className="relative aspect-[4/5] overflow-hidden border border-[#262626]">
                        <img
                            src={ABOUT_IMG}
                            alt="Equipo en obra civil RAMSOL"
                            className="w-full h-full object-cover"
                            data-testid="nosotros-image"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
                        <div className="absolute bottom-0 left-0 p-6">
                            <p className="text-[10px] uppercase tracking-[0.25em] text-[#14888F]">Desde 2017</p>
                            <p className="mt-2 text-white text-sm md:text-base font-medium leading-snug max-w-xs">
                                Sólida experiencia en sistemas constructivos de vanguardia.
                            </p>
                        </div>
                    </div>
                    <div className="hidden md:block absolute -bottom-6 -right-6 w-32 h-32 bg-[#14888F] -z-0 pointer-events-none" />
                </div>
            </div>
        </section>
    );
}
